/**
 * Tipo de logo da empresa. Espelha `ATS.Hub.API.Usuario.Enums.TipoLogoEmpresa` no backend
 * e os IDs canonicos seedados em `empresa_logo_tipo`.
 *
 * O backend usa `StringEnumConverter`, entao o JSON trafega o NOME do enum (ex.: "Principal").
 * Para adicionar um novo tipo no futuro: criar a entry no enum aqui, no backend e no banco.
 */
export enum TipoLogoEmpresa {
    Principal = 'Principal',
}
